var StoreSelector = function (config) {
  var _data = {};
  const mobileBreakPointHeight = 550;
  const mobileBreakPointWidth = 768;
  const distanceThreshold = 25; // used to decide to show or not the NL facet, and to center the map on close by stores

  // Select correct Store facet from list
  function goToStoreFacet(store){

    // Reset search bar
    $('#'+_data.id+'search_input').val('');

    resetMarkersImage();
    highlightStore(store.store_id);

    // Close all opened store details
    $('.'+_data.id+'store_details_div').hide();
    // Scroll to the selected store Facet
    var store_index = $('#'+_data.id+store.store_id).index();
    scroll_height = 0;
    $('#'+_data.id+'store_list .store-selector_shop').each(function(){
      if(store_index > $(this).index()){
        scroll_height = scroll_height + $(this).outerHeight();
      }
    });
    $('#'+_data.id+'store_list').animate({scrollTop: scroll_height}, 'fast');

    if(!_data.is_modal){
      document.body.scrollTo(0, _data.section_top_offset);
    }
  };

  // Center on selected store
  function goToMapLocation(store, zoneCenter){
    if(store.type == "livraison"){
      _data.map.setZoom(11);
    }else{
      _data.map.setZoom(11);
    }

    _data.map.setCenter(zoneCenter);

    resetMarkersImage();
    highlightStore(store.store_id);

  };

  function addPickupStoreToMap(store){
  	// Create Store Marker on Map
    var map = _data.map;
    const store_marker = new google.maps.Marker({
      position: { lat: parseFloat(store.lat), lng: parseFloat(store.long)},
      map,
      title: "Click to zoom",
      store: store,
      icon: store.is_point_relais ? _data.marker_point_relais_img_url : _data.marker_img_url
    });

    // Add click listener on Map Marker
    store_marker.addListener(
      "click",
      () => {
        _data.map.setZoom(11);
      	_data.map.setCenter(store_marker.getPosition());
      	goToStoreFacet(store);
      }
    );

    // Add click listener on facet
    $('#'+_data.id+store.store_id+'_link').on('click', function(event){
      event.stopPropagation();
      goToMapLocation(store, store_marker.getPosition());
    });

  	// Add click listener on map button (mobile only)
    $('#'+_data.id+store.store_id+'_open_map_button').on('click', function(event){
      event.stopPropagation();
      goToMapLocation(store, store_marker.getPosition());
      $('#'+_data.id+'mobile_display_map_button').click();
    });

  	//Add map markers to data dict
    _data.map_markers[store.store_id] = store_marker;
  };

  function addDeliveryZoneToMap(store){
    try {
  	  const delivery_zones = JSON.parse(store.delivery_zone);
      strokeOpacity = 0.2;
      strokeWeight= 2;
      for (const paths of delivery_zones)  {
        const polygon = new google.maps.Polygon({
          paths: paths,
          strokeColor: "#fcc742",
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: "#fcc742",
          fillOpacity: 0.4,
        });

        polygon.setMap(_data.map);
        var zoneCenter = new google.maps.LatLng(
          parseFloat(store.lat), parseFloat(store.long)
        );

        // Add click listener on Map Zone
        polygon.addListener(
          "click",
          () => {
            _data.map.setZoom(11);
          	_data.map.setCenter(zoneCenter);
          	goToStoreFacet(store);
          }
        );

        // Add click listener on facet
        $('#'+_data.id+store.store_id+'_link').on('click', function(event){
          event.stopPropagation();
          goToMapLocation(store, zoneCenter);
        });

        // Add click listener on map button (mobile only)
        $('#'+_data.id+store.store_id+'_open_map_button').on('click', function(event){
          event.stopPropagation();
          goToMapLocation(store, zoneCenter);
          $('#'+_data.id+'mobile_display_map_button').click();
        });
      }
	}catch(ex){
      console.log(ex);
    }

  };

  function addStoreToMap(store, index, array) {
    if(store.type == 'retrait' || store.type == 'supermarche'){
      addPickupStoreToMap(store);
    }else{
      addDeliveryZoneToMap(store);
    }
  };

  var initMap = function(){
    const map = new google.maps.Map($("#"+_data.id+"map__box")[0]);
    _data['map'] = map;
    _data.stores.forEach(addStoreToMap);
    _data.places_service =  new google.maps.places.PlacesService(_data.map);

    // place marker for later use to materialize searched location and hide it for now
    _data.searchMarker = new google.maps.Marker({map: _data.map});

    resetMap(false);
  };

  var resetMap = function(){
    _data.searchMarker.setVisible(false);

    if(_data.clientLocation){ //if client geoloc is active we don't need to center and zoom on france
      return;
    }
    let coordCenter = {
      lat: 46.654253824322645,
      lng: 2.4980414943317983
    };

    let zoom_level = 5.5;

    if(!_data.is_modal && window.innerWidth < mobileBreakPointWidth){
      coordCenter.lat = 49.60977082503113;
      coordCenter.lng = 2.207261607210151;
      zoom_level = 5.25;
    };

    if(window.innerHeight < mobileBreakPointHeight){
      coordCenter.lat = 47.654253824322645;
      coordCenter.lng = 2.207261607210151;
      zoom_level = 4.9;
    };
    _data.map.setCenter(coordCenter);
    _data.map.setZoom(zoom_level);
  }

  function initStoreFacet(store, index, array) {
    var today_weekday = moment().day();
    var today_hour = moment();
    moment.locale('fr-fr');

    var store_weekly_hours = {
      0: {
        "start": store.sunday_open,
        "end": store.sunday_close
      },
      1: {
        "start": store.monday_open,
        "end": store.monday_close
      },
      2: {
        "start": store.tuesday_open,
        "end": store.tuesday_close
      },
      3: {
        "start": store.wednesday_open,
        "end": store.wednesday_close
      },
      4: {
        "start": store.thursday_open,
        "end": store.thursday_close
      },
      5: {
        "start": store.friday_open,
        "end": store.friday_close
      },
      6: {
        "start": store.saturday_open,
        "end": store.saturday_close
      }
    };

    var store_sod = store_weekly_hours[today_weekday]['start'];
    var store_eod = store_weekly_hours[today_weekday]['end']
    var sod_time = moment(store_sod, 'H:mm');
    var eod_time = moment(store_eod, 'H:mm');
    var html_open_or_closed = "";
    if(store.type == "retrait" || store.type == "supermarche" || store.store_id == "livraison-bordeaux" || store.store_id == "livraison-toulouse-agglo" || store.store_id == "livraison-lille" ){
      // TODO find a way to have a cleaner way to integrate Yper delivery hours
      // Store is closed today or we passed opened hours, we look for the next opened day
      if(store_sod == "closed" || store_eod == "closed" || moment().isAfter(eod_time)){
        let next_opened_day_found = false;
        let days_from_today = 1;
      	let next_day = (today_weekday + 1) % 7;
        store_sod = store_weekly_hours[next_day]["start"];
        store_eod = store_weekly_hours[next_day]["end"];
        while(next_day != today_weekday && !next_opened_day_found && days_from_today < 7){
          if(store_sod != "closed" && store_eod != "closed"){
            next_opened_day_found = true;
          }else{
          	next_day = (next_day + 1) % 7;
          	days_from_today += 1;
          }
          store_sod = store_weekly_hours[next_day]["start"];
          store_eod = store_weekly_hours[next_day]["end"];
        }

        sod_time = moment(store_sod, 'H:mm');
    	  eod_time = moment(store_eod, 'H:mm');
        // Store is open tomorrow

        if(next_opened_day_found && days_from_today == 1){
          if(store.type == "retrait" || store.type == "supermarche" ){
            html_open_or_closed = "<span style='color: #F0695B'>• Fermé</span> - ouvre demain à " + sod_time.format('HH:mm');
          }else{ // only for livraison-bordeaux
            html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible</span> - à partir de demain " + sod_time.format('HH:mm');
          }

        }else if(next_opened_day_found){
          // Store will be open in the next following days (within a week)
          if(store.type == "retrait" || store.type == "supermarche" ){
            html_open_or_closed = "<span style='color: #F0695B'>• Fermé</span> - ouvre " + moment.weekdays(next_day) + " à " + sod_time.format('HH:mm');
          }else{ // only for livraison-bordeaux
            html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible</span> - à partir de " + moment.weekdays(next_day) + " à " + sod_time.format('HH:mm');
          }
        }else{
          // Store is closed (at least for one week)
          if(store.type == "retrait" || store.type == "supermarche" ){
            html_open_or_closed = "<span style='color: #F0695B'>• Fermé</span>";
          }else{ // only for livraison-bordeaux
            html_open_or_closed = "<span style='color: #F0695B'>• Livraison indisponible</span>";
          }
        }
      }else{
        // Store not yet opened today
        if(moment().isBefore(sod_time)){
          if(store.type == "retrait" || store.type == "supermarche" ){
            html_open_or_closed = "<span style='color: #F0695B'>• Fermé</span> - ouvre aujourd'hui à " + sod_time.format('HH:mm');
          }else{ // only for livraison-bordeaux
            html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible</span> - à partir " + sod_time.format('HH:mm');
          }
        }else{
        	// Store is open today
          if(store.type == "retrait" || store.type == "supermarche" ){
            html_open_or_closed = "<span style='color: #47BA46'>• Ouvert</span> - jusqu’à " + eod_time.format('HH:mm');
          }else{ // only for livraison-bordeaux
            html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible</span> - jusqu'à " + eod_time.format('HH:mm');
          }
        }
      }
    }else{
      // Fetch the next delivery day
      let next_delivery_day_found = false;
      let days_from_today = 1;
      let next_day = (today_weekday + 1) % 7;
      store_sod = store_weekly_hours[next_day]["start"];
      store_eod = store_weekly_hours[next_day]["end"];
      while(next_day != today_weekday && !next_delivery_day_found && days_from_today < 7){
        if(store_sod != "closed" && store_eod != "closed"){
          next_delivery_day_found = true;
        }else{
          next_day = (next_day + 1) % 7;
          days_from_today += 1;
        }
        store_sod = store_weekly_hours[next_day]["start"];
        store_eod = store_weekly_hours[next_day]["end"];
      }

      sod_time = moment(store_sod, 'H:mm');
      eod_time = moment(store_eod, 'H:mm');
      // Delivery is available tomorrow
      if(next_delivery_day_found && days_from_today == 1){
        html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible </span> - à partir de demain " + sod_time.format('HH:mm');
      }else if(next_delivery_day_found){
        // Delivery is available after tomorrow and within one week
        html_open_or_closed = "<span style='color: #47BA46'>• Livraison disponible </span> - à partir de " + moment.weekdays(next_day) + " " + sod_time.format('HH:mm');
      }else{
        // Delivery is not possible at least until one week
        html_open_or_closed = "<span style='color: #F0695B'>• Livraison indisponible</span>";
      }

    }
    $('#'+_data.id+store.store_id+"_open_or_closed").html(html_open_or_closed);
    $('#'+_data.id+store.store_id+'_details_button').on('click', function(event){
      event.stopPropagation();
      // close all details div first
      $('.store-selector_store_details_div').hide();
      if($('#'+_data.id+store.store_id+'_details_div').css('display') == "flex"){
        $('#'+_data.id+store.store_id+'_details_div').hide();
      } else {
        $('#'+_data.id+store.store_id+'_details_div').css('display', 'flex');
      }
    });

    $('#'+_data.id+store.store_id+'_select_button').on('click', function(event){
      event.stopPropagation();
      setCookie("ldtn_store", store.store_id);
      var product_title = getCookie('product_title');
      var product_search_query = getCookie('product_search_query');
      if(product_search_query != "" && product_search_query != null){
      	location.href = 'https://'+store.subdomain+".ledrivetoutnu.com/search?q="+product_search_query;
      }else if(product_title != "" && product_title != null){
      	location.href = 'https://'+store.subdomain+".ledrivetoutnu.com/search?q="+product_title;
      }else{
        if(store.url == ""){
          location.href = 'https://'+store.subdomain+".ledrivetoutnu.com?ldtn_store="+store.store_id;
        }else{
          location.href = store.url;
        }
      }
    });
  };

  function initShopList(){
    for(let store of _data.stores){
      _data.shop_list.push({
        name: store.name,
        keywords: store.keywords,
        id: store.store_id,
        type: store.type,
        order: store.order,
        lat: store.lat,
        lng: store.long,
        is_point_relais: store.is_point_relais,
        distance: 0
      });
    }
    return;
  }

  function populateDistances(originLocation = false){
    if(!originLocation){
      return;
    }
    for (let i = 0; i < _data.shop_list.length; i++) {
      _data.shop_list[i].distance = haversineDistance(new google.maps.LatLng(_data.shop_list[i].lat, _data.shop_list[i].lng),originLocation);
      _data.shop_list[i].distance = _data.shop_list[i].is_point_relais ? _data.shop_list[i].distance + 10 : _data.shop_list[i].distance;
      
    }
  }


  var initStoreListDom = function(){
    _data.stores.forEach(initStoreFacet);
  };

  var resetMarkersImage = function(){
    // set all the store markers back to normal
    for (const [id, marker] of Object.entries(_data.map_markers)) {
      marker.setIcon(marker.store.is_point_relais ? _data.marker_point_relais_img_url : _data.marker_img_url);
    }
  };

  var initFacetsOrder = function(){
    if(window.innerWidth < mobileBreakPointWidth){ // execute if mobile -> tiles loaded won't trigger if map is hidden
      updateFacetsOrder(false);
    }
    google.maps.event.addListenerOnce(_data.map, 'tilesloaded', function(){updateFacetsOrder(false); });
  }

  var updateFacetsOrder = function(originLocation = false, isSearch = false) {
  function orderFacets(originLocation = false, isSearch = false){
    var geoLoc = originLocation ? originLocation : _data.clientLocation ? _data.clientLocation : false;
    populateDistances(geoLoc);

    orderShopList(geoLoc);
    updateMap(_data.shop_list[0], geoLoc, isSearch);
  }
   if (navigator.geolocation && originLocation == false) { // if browser can geolocate
      orderFacets(false, isSearch);
      navigator.geolocation.getCurrentPosition(function (position) { // if/when geolocation is allowed by user init originlocation, and updateFacetsOrder (order list and canter map)
        _data.clientLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        orderFacets(_data.clientLocation, isSearch);
      });
    }else{
      orderFacets(originLocation, isSearch);
    }
  };

  // create autocomplete search bar
  var initSearchBar = function(){
    const options = {
      types: ['(regions)'],
      componentRestrictions: {country: 'fr'},
    };
    const input = $('#'+_data.id+'search_input');
    const autocomplete = new google.maps.places.Autocomplete(input[0], options);
    autocomplete.setFields(['address_components', 'geometry', 'name']);
    // when a place is selected or enter key up
    autocomplete.addListener('place_changed', async () =>{
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        // we search and return the closest place that match its criteria = name of place
        textSearchLocation(place.name);
      }else{

        // show marker and set it to searched location
        _data.searchMarker.setPosition(place.geometry.location);
        _data.searchMarker.setVisible(true);
        // init search with search geolocation on
        updateFacetsOrder(place.geometry.location, true);
      }
      return;
    });
  };

  function textSearchLocation(name){

    _data.places_service.textSearch({query: name}, function (results, status) {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        for (var i = 0; i < results.length; i++) {

          // show marker and set it to searched location
          _data.searchMarker.setPosition(results[i].geometry.location);
          _data.searchMarker.setVisible(true);

          // init search with search geolocation on
          updateFacetsOrder(results[i].geometry.location, true);
          return;
        }
      }else{
        // this is very unlikely to happen : zéro result on google maps
        console.log('location not found');
      }
    });

  }


  // center map between closest store and originlocation (current location or searched location)
  // list needs to be sorted first by orderShopList
  var updateMap = function(store, originLocation, isSearch = false){
    if(!originLocation){
      return;
    }

    // get closest store and its location
    storeLocation = new google.maps.LatLng(store.lat, store.lng);

    // set new bounds and add closest store and originlocation to it
    var latlngbounds = new google.maps.LatLngBounds();
    latlngbounds.extend(storeLocation);
    latlngbounds.extend(originLocation);
    latlngbounds = addCloseStoresToBounds(latlngbounds, originLocation, _data.shop_list, distanceThreshold);
    _data.map.setCenter(latlngbounds.getCenter());

    calculated_zoom = getZoomByBounds( _data.map, latlngbounds );
    if(calculated_zoom > 11.75){
      calculated_zoom = 11;
    }
    // adjust for smaller screens
    if(window.innerHeight < mobileBreakPointHeight || window.innerWidth < mobileBreakPointWidth){
      if(calculated_zoom > 11){
        calculated_zoom = 11;
      }
    }
    _data.map.setZoom(calculated_zoom);

    resetMarkersImage();

    // if closest store further than 25km show NL card and put it on top
    if(store.distance > distanceThreshold){
      $('#'+_data.id+'not_found_item').show();
      $('#'+_data.id+'not_found_item').prependTo($('#'+_data.id+'not_found_item').parent());
    }else{ // otherwise highlight and select closest store
      $('#'+_data.id+'not_found_item').hide();
      if(isSearch){
        highlightStore(store.id);
      }
    }
  }

  var highlightStore = function(store_id){
    resetHightlightedStores();
    ///highlight facet
    $('#'+_data.id+store_id).addClass('highlighted');
    // change selected map marker
    if(store_id in _data.map_markers){
      _data.map_markers[store_id].setIcon(_data.marker_hover_img_url);
    }
  };

  var resetHightlightedStores = function(){
    $('.'+_data.id+"store_facet").each(function(){
        $(this).removeClass('highlighted');
    });
  };

  var orderShopList = function(geoLoc = false){
    // Alphabetical sorting is done according to the view :
    // - basic = order from order field in theme settings
    // - "retrait" first then "livraison" and alphabetical order
    // - "livraison" first then "retrait" and alphabetical order
    if (geoLoc) { // if geoloc activated or this is a search, sort by distance
      _data.shop_list.sort(dynamicSort(_data.storeType,'distance'));
    }else{ // other wise sort by the order field
      _data.shop_list.sort(dynamicSort(_data.storeType, 'order'));
    }

    _data.shop_list.forEach(function(shop) {
      $("#"+_data.id+shop.id).insertBefore("#"+_data.id+'not_found_item');
    });
  };

  var initMobile = function(){

    $('#'+_data.id+'mobile_display_map_button').on('click', function(event){
      event.stopPropagation();
      $('#'+_data.id+'mobile_close_map_button').show();
      $('#'+_data.id+'map__box').show();
      $('#'+_data.id+'map__box').css("position", "fixed");
      $('#'+_data.id+'map__box').css("overflow", "hidden");
      if(_data.is_modal){
        $('#'+_data.id+'map__box').css("height", "95vh");
      }else{
        $('#'+_data.id+'map__box').css("height", "75vh");
      }
      $('#'+_data.id+'map__box').css("width", "100vw");
      $('#'+_data.id+'map__box').css("left", "0");
      $('#'+_data.id+'map__box').css("bottom", "0");
    });

    $('#'+_data.id+'mobile_close_map_button').on('click', function(event){
      event.stopPropagation();
      $('#'+_data.id+'mobile_close_map_button').hide();
	  $('#'+_data.id+'map__box').hide();
    });

    if(!_data.is_modal){
      $('#'+_data.id+'mobile_close_map_button').css("top", "140px");
    }

  };

  var fetchSectionOffsetTop = function(id){
    const HEADER_HEIGHT = 190;
  	var section_offset = $('#'+id+"container").offset();
    return section_offset.top - HEADER_HEIGHT;
  };

  function dynamicSort(optionSorting, sortType) {
      return function (a,b) {
          const aSortValue = a[sortType];
          const bSortValue = b[sortType];
          // If the display is not, the default display (either "livraison" first or "retrait" first)
          if(optionSorting && optionSorting != 'basic'){
            const aType = a.type;
            const bType = b.type;
            if(aType == bType)
              // Sort by alphabetical order for each type
              return(aSortValue < bSortValue) ? -1 : (aSortValue > bSortValue) ? 1 : 0;
            else
              return optionSorting == 'livraison' ?
                ((aType < bType) ? -1 : 1) : // If we sort by "livraison" first
                ((aType < bType) ? 1 : -1); // If we sort by "retrait" first
          }
          // Sort by alphabetical order
          return (aSortValue < bSortValue) ? -1 : (aSortValue > bSortValue) ? 1 : 0;
      }
  }
  // flight distance between two point in kilometers
  // found on stackoverflow https://stackoverflow.com/a/30316500
  function haversineDistance(coords1, coords2, isMiles) {

    function toRad(x) {
      return x * Math.PI / 180;
    }

    var lon1 = coords1.lng();
    var lat1 = coords1.lat();
    var lon2 = coords2.lng();
    var lat2 = coords2.lat();

    var R = 6371; // km

    var x1 = lat2 - lat1;
    var dLat = toRad(x1);
    var x2 = lon2 - lon1;
    var dLon = toRad(x2)
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;

    if(isMiles) d /= 1.60934;

    return d;
  }

  /**
  * Returns the zoom level at which the given rectangular region fits in the map view.
  * The zoom level is computed for the currently selected map type.
  * https://stackoverflow.com/questions/9837017/equivalent-of-getboundszoomlevel-in-gmaps-api-3
  * @param {google.maps.Map} map
  * @param {google.maps.LatLngBounds} bounds
  * @return {Number} zoom level
  **/
  function getZoomByBounds( map, bounds ){

    var MAX_ZOOM = map.mapTypes.get( map.getMapTypeId() ).maxZoom || 21 ;
    var MIN_ZOOM = map.mapTypes.get( map.getMapTypeId() ).minZoom || 0 ;

    var ne= map.getProjection().fromLatLngToPoint( bounds.getNorthEast() );
    var sw= map.getProjection().fromLatLngToPoint( bounds.getSouthWest() );

    var worldCoordWidth = Math.abs(ne.x-sw.x);
    var worldCoordHeight = Math.abs(ne.y-sw.y);

    //Fit padding in pixels
    var FIT_PAD = 10;
    for( var zoom = MAX_ZOOM; zoom >= MIN_ZOOM; --zoom ){
        if( worldCoordWidth*(1<<zoom)+2*FIT_PAD < $(map.getDiv()).width() &&
            worldCoordHeight*(1<<zoom)+2*FIT_PAD < $(map.getDiv()).height() )
            return zoom;
    }
    return 0;
  }


  // if other stores are close by show them on the map
  function addCloseStoresToBounds(latlngbounds, originLocation, stores, distanceThreshold){
    for (let i = 0; i < stores.length; i++) {
      if(stores[i].distance < distanceThreshold){
        latlngbounds.extend(new google.maps.LatLng(stores[i].lat, stores[i].lng));
      }
    }
    return latlngbounds;
  }

  return {
    id: config.id,
    stores: config.stores,
    is_modal: config.is_modal,
    marker_img_url: config.marker_img_url,
    marker_point_relais_img_url: config.marker_point_relais_img_url,
    marker_hover_img_url: config.marker_hover_img_url,

    init: function () {
      _data = {
    	  id: this.id,
        stores: this.stores,
     	  is_modal: this.is_modal,
        marker_img_url: this.marker_img_url,
        marker_point_relais_img_url: this.marker_point_relais_img_url,
        marker_hover_img_url: this.marker_hover_img_url,
        section_top_offset: fetchSectionOffsetTop(this.id),
        map: null,
        map_markers: {},
        places_service : null,
        shop_list : [],
        clientLocation : false, // either user location or searched location
        searchMarker : {}, // the marker used to materialize  searched location
        storeType : "basic"
      };

      initStoreListDom(); // create store list and facets in dom
      initShopList(); // create shop array for calculating distances and controling icon on map
      initMap(); // init map
      initFacetsOrder();
      initSearchBar(); // init autocomplete search bar
      initMobile();
    },

    resetModal: function(){
      resetMap();
      resetMarkersImage();
      resetHightlightedStores();
      $('#'+_data.id+'store_list').scrollTop(0);
      $('#'+_data.id+'search_input').val("");
    },


    displayPickupStores: function () {
      _data.storeType = "retrait";
      updateFacetsOrder(_data.clientLocation);
    },

    displayDeliveryStores: function () {
      _data.storeType = "livraison";
      updateFacetsOrder(_data.clientLocation);
    }
  };
};
